import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import API_BASE from "../config/api";

export default function UserProfile() {
    const [formData, setFormData] = useState({
        id: "",
        fullname: "",
        email_username: "",
        mobile: "",
        password: ""
    });

    const [isGoogleUser, setIsGoogleUser] = useState(false);
    const defaultImage = `${API_BASE}/backend/uploads/default.png`;

    const userId = new URLSearchParams(window.location.search).get("userid");

    useEffect(() => {
        if (!userId) return;

        fetch(`${API_BASE}/api/get_user_data.php?userid=${userId}`)
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    const u = data.user;
                    setFormData({
                        id: u.id,
                        fullname: u.fullname || "",
                        email_username: u.email || u.username || "",
                        mobile: u.mobile || "",
                        password: ""
                    });

                    setIsGoogleUser(u.login_type === "google");
                } else {
                    Swal.fire("Error", data.message, "error");
                }
            })
            .catch((err) => {
                console.error(err);
                Swal.fire("Error", "Failed to load user data", "error");
            });
    }, [userId]);

    const updateField = (e) => {
        if (isGoogleUser) return;
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSave = async () => {
        try {
            const res = await fetch(`${API_BASE}/api/update_user_profile.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const data = await res.json();

            if (data.success) {
                Swal.fire("Success!", "Profile updated successfully", "success");
            } else {
                Swal.fire("Error!", data.message, "error");
            }
        } catch (err) {
            console.error(err);
            Swal.fire("Error!", "Failed to save profile", "error");
        }
    };

    return (
        <div className="container py-4" style={{ maxWidth: "650px" }}>
            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <h3 className="mb-4 text-center fw-bold">User Profile</h3>

                    <div className="text-center mb-3">
                        <img
                            src={defaultImage}
                            width="110"
                            height="110"
                            className="rounded-circle shadow"
                            alt="profile"
                        />
                        {isGoogleUser && (
                            <p className="text-danger fw-bold mt-2">
                                (Google Login – Editing Disabled)
                            </p>
                        )}
                    </div>

                    {/* Full Name */}
                    <div className="mb-3">
                        <label className="fw-semibold">Full Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="fullname"
                            value={formData.fullname}
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* One Single Field */}
                    <div className="mb-3">
                        <label className="fw-semibold">Email / Username</label>
                        <input
                            type="text"
                            className="form-control"
                            name="email_username"
                            value={formData.email_username}
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* Mobile */}
                    <div className="mb-3">
                        <label className="fw-semibold">Mobile</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile"
                            value={formData.mobile}
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {/* Password */}
                    <div className="mb-3">
                        <label className="fw-semibold">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            name="password"
                            placeholder="Enter new password (optional)"
                            onChange={updateField}
                            disabled={isGoogleUser}
                        />
                    </div>

                    {!isGoogleUser && (
                        <button className="btn btn-primary w-100" onClick={handleSave}>
                            Save Profile
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
